// Installs a global fetch() wrapper that attaches the signed HR token to every
// same-origin /backend/hr-api/ request. Covers the many raw fetch() call sites
// (notifications, documents, settings, payroll, self-service, training) that do
// not go through the axios apiClient interceptor. Imported once from index.tsx.
(function () {
  if (typeof window === 'undefined' || (window as any).__hrAuthFetch) return;
  (window as any).__hrAuthFetch = true;
  const orig = window.fetch.bind(window);
  window.fetch = (input: any, init?: any) => {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url && url.indexOf('/backend/hr-api/') !== -1) {
        const t = localStorage.getItem('hr_access_token') || localStorage.getItem('hr_token') || localStorage.getItem('token');
        if (t) {
          init = init || {};
          const headers = new Headers((init && init.headers) || {});
          if (!headers.has('Authorization')) headers.set('Authorization', 'Bearer ' + t);
          init.headers = headers;
        }
      }
    } catch (e) { /* ignore */ }
    return orig(input, init);
  };
})();
export {};
